import { LeadStatus } from "./calender.model";
import { ClassCodes } from "./classCodes.model";
import { CLPUser, OfficeCodes, TeamCodes } from "./clpuser.model";
import { Contact } from "./contact.model";
import { eCompanyType, eNoteOwnerType, eSplit_Appt2Dim, eStatusFilter, eTaskCategory, eTaskStatus, SearchContactBy } from "./enum.model";
import { DropDownItem, IntDropDownItem, SimpleResponse } from "./genericResponse.model";
import { keyValue, SearchQueryResponse } from "./search.model";

export interface ApptTypeSummaryResponse extends SimpleResponse {
    appointmentListMonth: Appointment[];
    appointmentListYTD: Appointment[];
}

export interface Appointment {
    display: string;
    Pending: number;
    Completed: number;
    Cancelled: number;
}

export interface ApptTwoDimensionResponse {
    ddRowColumns: IntDropDownItem[];
    clpUserFilter: ClpUserFilterResponse;
    ddStatus: IntDropDownItem[];
    //appointmentTwoDimension: {}[];
    appointmentTwoDimension: { Total: string } [];
}

export interface ClpUserFilterResponse {
    isUserDd: boolean;
    isTeamDd: boolean;
    isOfficeDd: boolean;
    isMyOffice: boolean;
    isMyTeam: boolean;
    userDD: IntDropDownItem[];
    myOfficeText: string;
    myTeamText: string;
    lblCLPUserList: string;
    teamDd: TeamCodes[];
    officeDd: OfficeCodes[];
}

export interface QualCallReportResponse extends SimpleResponse {
    spanTitleText: string;
    qualCallList: [];
}

export interface LoadSecuredUserResponse extends SimpleResponse {
    userList: IntDropDownItem[]
}

export interface NoteTypeSummaryResponse extends SimpleResponse {
    spanTitleText: string;
    noteTypeSummaryList: [];
}

export interface CallActionScreenResponse {
    spanTitleText: string;
    clickReport: [];
}

export interface EmailOpenRateReportResponse extends SimpleResponse {
    emailOpenRateReportList: EmailOpenRateReport[];
}

export interface EmailOpenRateReport {
    subject: string;
    emailType: string;
    sentDate: Date;
    all: number;
    opened: number;
    openRate: number;
}

export interface clpUserFilterResponse {
    isUserDd: boolean;
    isTeamDd: boolean;
    isOfficeDd: boolean;
    isMyOffice: boolean;
    isMyTeam: boolean;
    userDD: IntDropDownItem[];
    myOfficeText: string;
    myTeamText: string;
    lblCLPUserList: string;
    teamDd: TeamCodes[];
    officeDd: OfficeCodes[];
}

export interface CompanyTwoDimensionResponse extends SimpleResponse {
    ddRowsColumns: IntDropDownItem[];
    userFilterData: clpUserFilterResponse;
    companyTwoDimension: {}[];
}
export interface userListResponse {
    userDD: keyValue[];
}

export interface ContactDisByManagerResponse {
    ddView: keyValue[];
    distributionByManagerList: DistributionResponse;
}

export interface ContactDisByClassifictaionResponse extends SimpleResponse {
    userList: IntDropDownItem[];
    isUserDD: boolean;
    classification: IntDropDownItem[];
    distributionByClassificationList: DistributionResponse;
}

export interface DistributionResponse {
    strCHTitle: string;
    message: string;
    distributionList: { Contacts: number, contactName: string, Split: string }[];
}

export interface ContactTwoDimensionResponse extends SimpleResponse {
    ddRowsColumns: IntDropDownItem[];
    userFilterData: clpUserFilterResponse;
    contactTwoDimension: { Total: string }[];
}

export interface TxtMsgRpt {
    uFirstName: string
    uLastName: string
    referralID: number
    companyID: number
    salutation: string
    title: string
    companyName: string
    add1: string
    add2: string
    add3: string
    city: string
    state: string
    zip: string
    country: string
    custom1: string
    custom2: string
    custom3: string
    custom4: string
    custom5: string
    custom6: string
    custom7: string
    custom8: string
    custom9: string
    custom10: string
    custom11: string
    custom12: string
    custom13: string
    custom14: string
    custom15: string
    custom16: string
    check1: boolean
    check2: boolean
    check3: boolean
    check4: boolean
    check5: boolean
    check6: boolean
    phone: string
    homePhone: string
    altPhone: string
    fax: string
    otherFax: string
    eBlastAddress: number
    email2: string
    email3: string
    webSite: string
    class1Code: number
    class2Code: number
    class3Code: number
    class4Code: number
    class5Code: number
    class6Code: number
    class7Code: number
    class8Code: number
    comments: string
    shareable: boolean
    hasBeenEdited: boolean
    outlookSync: boolean
    dtModified: Date
    eVID: number
    isOptOutTxtMsg: number
    isOptOutEmail: boolean
    custom17: string
    custom18: string
    custom19: string
    custom20: string
    lastFirst: string
    firstName: string
    lastName: string
    email: string
    mobile: string
    txtMsgID: number
    cLPCompanyID: number
    cLPUserID: number
    contactID: number

    countryCode: string
    mobileNumber: string
    msg: string
    status: number
    requestID: string
    requestComment: string
    campaignID: number
    campaignEventID: number
    runID: number
    cLPServiceRunID: number
    dtSend: Date
    dtCreated: Date
    isToUser: boolean
    isUseShortCode: boolean
    mediaURL: string
    isThrottle: boolean
    toCLPUserID: number
    bWMessageId: string
    dtSentFromBW: Date
    dtSentToBW: Date
    txtMsgLongCode: string
    timeZoneWinId: number
    standardName: string
    class1Display: string
}

export interface TxtMsgIB {
    uFirstName: string
    uLastName: string
    referralID: number
    companyID: number
    salutation: string
    title: string
    companyName: string
    add1: string
    add2: string
    add3: string
    city: string
    state: string
    zip: string
    country: string
    custom1: string
    custom2: string
    custom3: string
    custom4: string
    custom5: string
    custom6: string
    custom7: string
    custom8: string
    custom9: string
    custom10: string
    custom11: string
    custom12: string
    custom13: string
    custom14: string
    custom15: string
    custom16: string
    check1: boolean
    check2: boolean
    check3: boolean
    check4: boolean
    check5: boolean
    check6: boolean
    phone: string
    homePhone: string
    altPhone: string
    fax: string
    otherFax: string
    eBlastAddress: number
    email2: string
    email3: string
    webSite: string
    class1Code: number
    class2Code: number
    class3Code: number
    class4Code: number
    class5Code: number
    class6Code: number
    class7Code: number
    class8Code: number
    comments: string
    shareable: boolean
    hasBeenEdited: boolean
    outlookSync: boolean
    dtModified: Date
    eVID: number
    isOptOutTxtMsg: number
    isOptOutEmail: boolean
    custom17: string
    custom18: string
    custom19: string
    custom20: string
    lastFirst: string
    firstName: string
    lastName: string
    email: string
    mobile: string
    txtMsgIBID: number
    cLPCompanyID: number
    cLPUserID: number
    contactID: number

    mobileNumber: string
    kEYWORD: string
    cONTENTS: string
    dATACAPTURE: string
    rAWText: string
    status: number
    cLPServiceRunID: number
    dtReceived: Date
    rECIPIENT: string
    media: string
    class1Display: string

}

export interface TxtMsgLogResponse extends SimpleResponse {
    txtMsgList: TxtMsgRpt[];
    txtMsgIBList: TxtMsgIB[];
}
export interface VoiceCallRpt {
    clpUserId: number
    user: string
    teamCode: number
    team: string
    officeCode: number
    office: string
    direction: boolean
    isScheduled: boolean
    contacts: number
    calls: number
    noRing: number
    less2min: number
    bt2to5min: number
    bt5to15min: number
    bt15to30min: number
    greater30min: number
    minutes: number
    connected: number
    answerRate: number
    pitchRate: number
    callsPerDay: number
    averageLength: number
    pitchCallsPerDay: number
}

export interface VoiceCallCancelRpt {
    clpUserId: number
    user: string
    teamCode: number
    team: string
    officeCode: number
    office: string
    action: string
    calls: number
    cnt: number
}
export interface VoiceCallRptResponse extends SimpleResponse  {
    voiceCallRptList: VoiceCallRpt[]
    vCRptListOutScheduled: VoiceCallRpt[]
    VCRptListOutClickToCall: VoiceCallRpt[]
    voiceCallCancelRptList: VoiceCallCancelRpt[]
    totalVoiceCallRptList: VoiceCallRpt[]
    allUserVoiceCallRptList: VoiceCallRpt[]
}

export interface SkypeCallAttemptByContactResponse extends SimpleResponse {
    skypeCallAttemptByContactList: SkypeCallAttemptByContact[];
}

export interface VoiceCallInboundFilterResponse extends SimpleResponse {
    isTeamDD: boolean;
    teamDD: TeamCodes[];
    isTeamTxt: boolean;
    teamTxt: string;
    isOfficeDD: boolean;
    officeDD: OfficeCodes[];
    isOfficeTxt: boolean;
    officeTxt: string;
    isUserDD: boolean;
    userDD: IntDropDownItem[];
    isUserTxt: boolean;
    userTxt: string;
}

export interface VoiceCallInboundResponse extends SimpleResponse {
    voiceCallInboundHourList: VoiceCallInbound[];
    voiceCallInboundDayofWeekList: VoiceCallInbound[];
}

export interface VoiceCallInbound {
    sorder: number;
    category: string;
    calls: number;
}

export interface SkypeCallAttemptByContact {
    contactID: number;
    referralID: number;
    cLPUserID: number;
    cLPCompanyID: number;
    companyID: number;
    firstName: string;
    lastName: string;
    salutation: string;
    title: string;
    companyName: string;
    add1: string;
    add2: string;
    add3: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    custom1: string;
    custom2: string;
    custom3: string;
    custom4: string;
    custom5: string;
    custom6: string;
    custom7: string;
    custom8: string;
    custom9: string;
    custom10: string;
    custom11: string;
    custom12: string;
    custom13: string;
    custom14: string;
    custom15: string;
    custom16: string;
    check1: boolean;
    check2: boolean;
    check3: boolean;
    check4: boolean;
    check5: boolean;
    check6: boolean;
    phone: string;
    homePhone: string;
    mobile: string;
    altPhone: string;
    fax: string;
    otherFax: string;
    eBlastAddress: number;
    email: string;
    email2: string;
    email3: string;
    webSite: string;
    class1Code: number;
    class2Code: number;
    class3Code: number;
    class4Code: number;
    class5Code: number;
    class6Code: number;
    class7Code: number;
    class8Code: number;
    comments: string;
    shareable: boolean;
    hasBeenEdited: boolean;
    outlookSync: boolean;
    dtModified: string;
    dtCreated: string;
    eVID: number;
    isOptOutTxtMsg: number;
    isOptOutEmail: boolean;
    custom17: string;
    custom18: string;
    custom19: string;
    custom20: string;
    uFirstName: string;
    uLastName: string;
    companyType: number;
    coCompanyName: string;
    contactID1: string;
    attempts: string;

}

export interface SAMVoiceCallReportObj {
    clpCompanyId: number;
    clpUserId: number;
    teamCode: number;
    officeCode: number;
    groupBy: string;
    startDate: string;
    endDate: string;
}

export interface SAMVoiceCallFilterResponse extends SimpleResponse {
    isTeamSection: boolean;
    isTeamdd: boolean;
    isTeamLabel: boolean;
    teamdd: TeamCodes[];
    teamTxt: string;
    isOfficeSection: boolean;
    isOfficedd: boolean;
    isOfficeLabel: boolean;
    officedd: OfficeCodes[];
    officeTxt: string;
    isGroupBydd: boolean;
    isGroupByLabel: boolean;
    groupBydd: DropDownItem[];
    groupByTxt: string;
}

export interface RevenueByClassificationFilterResponse extends SimpleResponse {
    ddClass: IntDropDownItem[];
    isTeamDd: boolean;
    teamDd: TeamCodes[];
    isOfficeDd: boolean;
    officeDd: OfficeCodes[];
    isUserDd: boolean;
    userDd: IntDropDownItem[];
    revenueByClassificationList: ProjectRevenueList[];
}

export interface RevenueByManagerFilterResponse {
    ddManager: IntDropDownItem[];
    revenueByManagerList: ProjectRevenueList[];
}

export interface ProjectRevenueListResponse extends SimpleResponse {
    projectRevenueList: ProjectRevenueList[];
}

export interface ProjectRevenueList {
    legend: string;
    legendId: number;
    split: string;
    leads: number;
    revenue: number;
    probability: number;
    projected: number;
    chartCategoryField: string;
}

export interface RevenueByMonth {
    displayMonth: string;
    monthKey: number;
    leads: number;
    revenue: number;
    volume: number;
    probability: number;
    projected: number;
    countProbability: number;
}

export interface RevenueByMonthResponse {
    revenueByMonthList: RevenueByMonth[]
}

export interface RevenueByMonthFilterResponse extends SimpleResponse {
    isTeamDd: boolean;
    teamDd: TeamCodes[];
    isOfficeDd: boolean;
    officeDd: OfficeCodes[];
    isUserDd: boolean;
    userDd: IntDropDownItem[];
    revenueByMonthList: RevenueByMonth[];
}

export interface LeadTwoDimensionResponse extends SimpleResponse {
    ddRowsColumns: IntDropDownItem[];
    ddMeasure: IntDropDownItem[];
    ddDateFilter: DropDownItem[];
    userFilterData: ClpUserFilterResponse;
    leadTwoDimension: [{}];
    leadSearchUserList: [{ nestedData: {} }];
}

export interface LeadInvoiceResponse extends SimpleResponse {
    leadInvoiceList: [{ Amount: number }];
}

export interface LeadInvoiceFilterResponse extends SimpleResponse {
    isUsedDd: boolean;
    userDd: IntDropDownItem[];
    userTxt: string;
    isShowDownloadBtn: boolean;
    isShowExportList: boolean;
    isShowNewBtn: boolean;
    lblTitle: string;
    leadStatusCodeDd: LeadStatus[];
}

export interface BuzzCoreFilterResponse extends SimpleResponse {
    isUserDd: boolean;
    userDd: IntDropDownItem[];
    scoreTypeDd: DropDownItem[];
    class1CodeDd: Class1Codes[];
    class1CodeHead: string;
    class4CodeDd: Class4Codes[];
    class4CodeHead: string;
}

export interface Class1Codes {
    class1Code: number;
    clpCompanyId: number;
    display: string;
    sOrder: number;
}

export interface Class4Codes {
    class4Code: number;
    clpCompanyId: number;
    display: string;
    sOrder: number;
}

export interface BuzzScoreResponse extends SimpleResponse {
    buzzScoreList: BuzzScore[];
}

export interface BuzzScore {
    contactID: number;
    clpUserID: number;
    firstName: string;
    email: string;
    phone: string;
    mobile: string;
    homePhone: string;
    uLastName: string;
    uFirstName: string;
    score: number;
    events: number
}

export interface ScoreHistoryResponse extends SimpleResponse {
    contactName: string;
    totalCount: number;
    scoreHistory: ScoreHistory[];
}

export interface ScoreHistory {
    contactID: number;
    score: number;
    type: number;
    dtCreated: Date
}
export interface BuzzScoreData {
    startDt: string;
    endDt: string;
    userFilter: number;
    scoreType: number;
    class1Code: number;
    class4Code: number;
}

export interface Referrer {
    contactID: number
    firstName: string
    lastName: string
    userName: string;
    email: string
    companyName: string
    clpUserID: number
    dtCreated: Date
    count: number
}
export interface ReferralReport {
    contactID: number
    refferalId: number
    firstName: string
    lastName: string
    userName: string;
    email: string
    companyName: string
    clpUserID: number
    dtCreated: Date

}

export interface ReferralReportResponse extends SimpleResponse {
    referralList: ReferralReport[]
}
export interface ReferrerReportResponse extends SimpleResponse {
    spanTitle: string;
    referrerList: Referrer[];
}

export interface ClickCountResponse extends SimpleResponse {
    clickCount: ClickCount[];
}
export interface ClickCount {
    clickId: number;
    destinationUrl: string;
    count: number;
}

export interface IHApptSetterActivityResponse {
    ihApptSetterActivityList: [];
}

export interface ContactSearchResultObj {
    clpCompanyId: number;
    clpUserId: number;
    strUsers: string[];
    selectedTagIds: number[];
    tagSearchType: number;
    clickId: number;
    searchContactBy: SearchContactBy;
    ownerType: eNoteOwnerType;
    startDate: string;
    endDate: string;
    eDim1: string;
    dim1Value: string;
    eDim2: string;
    dim2Value: string;
    dateFilter: string;
    companyType: eCompanyType;
    selectedCompanyId: number;
}

export interface ContactSearchResultResponse extends SimpleResponse {
    contactList: Contact[];
    contactCount: number;
}

export interface ContactSearchSetupResponse extends SimpleResponse {
    isShowDownloadBtn: boolean;
    isShowSendResultToNew: boolean;
    isShowNewBtn: boolean;
    sendResultToNewDD: IntDropDownItem[];
    isShowExportList: boolean;
}

export interface CLPUserFilterResponse {
    isMyTeam: boolean;
    isMyOffice: boolean;
    isTeamDd: boolean;
    isTeamText: boolean;
    teamDd: TeamCodes[];
    teamText: string;
    isOfficeDd: boolean;
    isOfficeText: boolean;
    officeDd: OfficeCodes[];
    officeText: string;
    isUserDd: boolean;
    userDD: IntDropDownItem[];
}
//This model is only for ui side
export interface SendMailInfo {
    isShow: boolean
    contactId: number
}

export interface ContactInfo {
    isShow: boolean
    contactId: number
    contact: Contact
}
//This model is only for ui side

export interface AgreementDashboardData {
    startDt: string;
    endDt: string;
    finalized: number;
    franchise: number;
    location: number;
    contactOwner: number;
    referralSource: number;
    marketingChannel: number;
    agreementType: number;
    orderBy: number;
}

export interface ScoreCardByCodeResponse extends SimpleResponse {
    scoreCardByCodeList: ScoreCardByCode[]
}

export interface ScoreCardByCode {
    code: string
    desc: string
    projectedContactsAdded: number
    contactsAdded: number
    callCount: number
    bipCreated: number
    bipScheduled: number
    bipRate: number
    bipShow: number
    bipShowRate: number
    showsPerLead: number
    bipSold: number
    subSold: number
    contracted: number
    downPayment: number
}

export interface ScorecardByCodeFilterResponse {
    isOfficeDD: boolean;
    OfficeTxt: string;
    officeDd: OfficeCodes[];
    isUserDD: boolean;
    userDisplayTxt: string
    userDd: IntDropDownItem[]
}

export interface ScorecardFilter {
    officeDd: OfficeCodes[];
    class7CodeDd: ClassCodes
    class7CodeHead: string;
    class8CodeDd: ClassCodes;
    class8CodeHead: string;
}

export interface ScorecardByKeywordFilterResponse {
    isOfficeDD: boolean;
    OfficeTxt: string;
    officeDd: OfficeCodes[];
    class7CodeDd: Class7Codes[];
    class7CodeHead: string;
    class8CodeDd: Class8Codes[];
    class8CodeHead: string;
}

export interface ScoreCardByKeywordResponse extends SimpleResponse {
    scoreCardByKeywordList: ScoreCardByKeyword[]
}

export interface Class7Codes {
    class7Code: number;
    clpCompanyId: number;
    display: string;
    sOrde: number;
}

export interface Class8Codes {
    Class8Code: number;
    clpCompanyId: number;
    display: string;
    sOrde: number;
}

export interface ScoreCardByKeyword {
    keyword: string;
    contactsAdded: number;
    callCount: number;
    bipCreated: number;
    bipScheduled: number;
    bipRate: number;
    bipShow: number;
    bipShowRate: number;
    showsPerLead: number;
}

export interface ScoreCardByKeywordData {
    startDate: string;
    endDate: string;
    officeCode: number;
    class7Code: number;
    class8Code: number;
}
export interface BIPClickByApptSetter {
    owner: string;
    setter: string;
    bipShow: number;
    bipNoShow: number;
    bipDead: number;
    total: number;
    cost: number;
    bipShowRat: number;
}

export interface BIPClickByApptSetterResponse {
    bipClickByApptSetterList: BIPClickByApptSetter[];
}

export interface BIPClickApptData {
    startDate: string;
    endDate: string;
    costPerAppt: number;
}

export interface ScoreCard {
    clpuserId: number;
    salesperson: string;
    officeDisplay: string;
    projectedContactsAdded: number;
    contactsAdded: number;
    callCount: number;
    bipCreated: number;
    bipScheduled: number;
    bipRate: number;
    bipShow: number;
    bipShowRate: number;
    showsPerLead: number;
    bipSold: number;
    subSold: number;
    contracted: number;
    downPayment: number;
    ppSOSold: number;
    psSold: number;
}

export interface ScorecardResponse extends SimpleResponse {
    scoreCardList: ScoreCard[];
}

export interface ScoreCardData {
    startDate: string;
    endDate: string;
    class6Code: number;
    officeGroup: number;
}

export interface ScorecardFilterResponse extends SimpleResponse {
    class6CodeDd: Class6Codes[];
    class6CodeHead: string;
}

export interface Class6Codes {
    class6Code: number;
    clpCompanyId: number;
    display: string;
    sOrder: number;
}

export interface ScoreCardByTVSource {
    code: string;
    contactsAdded: number;
    callCount: number;
    bipCreated: number;
    bipScheduled: number;
    bipRate: number;
    bipShow: number;
    bipShowRate: number;
    showsPerLead: number;
}

export interface ScoreCardByTVSourceResponse extends SimpleResponse {
    scoreCardByTVSourceList: ScoreCardByTVSource[];
}

export interface ScoreCardByTVSourceData {
    startDate: string;
    endDate: string;
    ddUser: number;
}

export interface ScoreCardCompare {
    clpuserId: number;
    salesperson: string;
    officeDisplay: string;
    period1ContactsAdded: number;
    period2ContactsAdded: number;
    period1CallCount: number;
    period2CallCount: number;
    period1BipCreated: number;
    period2BipCreated: number;
    period1BipScheduled: number;
    period2BipScheduled: number;
    period1BipRate: number;
    period2BipRate: number;
    period1BipShow: number;
    period2BipShow: number;
    period1BipShowRate: number;
    period2BipShowRate: number;
    period1ShowsPerLead: number;
    period2ShowsPerLead: number;
}

export interface ScoreCardCompareData {
    startDatePeriod1: string;
    endDatePeriod1: string;
    startDatePeriod2: string;
    endDatePeriod2: string;
}

export interface ScorecardCompareResponse extends SimpleResponse {
    scoreCardCompareList: ScoreCardCompare[];
}

export interface ScoreCardByApptSetter {
    clpUserID: string;
    userDisplay: string;
    contactsAdded: number;
    callCount: number;
    callsPerContact: number;
    markedDead: number;
    totalApptsLeadCall: number;
    totalBIPApptRate: number;
    totalBIPShows: number;
    totalBIPShowApptRate: number;
    totalBIPShowApptPerLeadRate: number;
    laterApptsLeadCall: number;
    laterBIPApptRate: number;
    laterBIPShows: number;
    laterBIPShowApptRate: number;
    laterBIPShowApptPerLeadRate: number;
    nowApptsLeadCall: number;
    nowBIPApptRate: number;
    nowBIPShows: number;
    nowBIPShowApptRate: number;
    nowBIPShowApptPerLeadRate: number;
}

export interface ScoreCardByApptSetterResponse extends SimpleResponse {
    scoreCardByApptSetterList: ScoreCardByApptSetter[];
}

export interface ScoreCardByApptSetterData {
    startDate: string;
    endDate: string;
}

export interface CoachCornerFilterData {
    startDate: Date;
    endDate: Date;
    ddUser: number;
}

export interface CoachCornerObjForAppt2Dim {
    rows: eSplit_Appt2Dim;
    column: eSplit_Appt2Dim;
    startDate: Date;
    endDate: Date;
    status: eStatusFilter;
    selUser: number;
}

export interface CoachCornerObjTask {
    startDate: Date;
    endDate: Date;
    status: eTaskStatus;
    category: eTaskCategory;
    selUser: number;
}

export interface CoachCornerObjForNoteHistory {
    startDate: Date;
    endDate: Date;
    selUser: number;
}

export interface LeadSearchResultGroupedresponse extends SimpleResponse {
    leadSearchResultGroupedList: LeadSearchResultGrouped[];
}

export interface LeadSearchResultGrouped {
    groupID: number;
    leadID: number;
    cnt: number;
    revenue: number;
    volume: number;
    contactID: number;
    companyID: number;
    userID: number;
    customMoney1: number;
    customMoney2: number;
    customMoney3: number;
    customMoney4: number;
    winProbability: number;
    imgUrl: string;
    groupDisplay: string;
    fullName: string;
    contactLast: string;
    companyName: string;
    dtStart: Date;
    dtCustom1: Date;
    dtEnd: Date;
    dtRevenue: Date;
    statusDisplay: string;
    leadClass9Display: string;
    navURL: string;
    contactURL: string;
    toolTip: string;
    userName: string;
    userNameSort: string;
    leadDesc: string;
    nextTask: string;
    nextTaskDate: Date;
    nextTaskDateDisplay: string;
    naTaskID: number;
    dtModified: Date;
    dtCreated: Date;
    projectedNet: number;
}

//For UI purpose only
export interface LeadSearchResult {
    LeadDesc: string;
    ContactLast: string;
    CompanyName: string;
    UserName: string;
    NextTask: string;
    RevenueShow: number;
    NextTaskDateDisplay: string;
    dtStartShow: Date;
    dtCustom1Show: Date;
    dtEndShow: Date;
    dtRevenueShow: Date;
    LeadClass9Display: string;
    VolumeShow: number;
    WinProbability: number;
    ProjectedNetShow: number;
    StatusDisplay: string;
    dtModifiedDisplay: Date;
    dtCreatedDisplay: Date;
    dtCreated: Date;
    LeadID: number;
    CLPCompanyID: number;
    CLPUserID: number;
    ContactID: number;
    ULastName: string;
    statusDisplay: string;
    groupDisplay: string;

    //UI
    total: {};

}
//For UI Only
export interface LeadSearchGroup {
    desc: string;
    VolumeShow: number;
    RevenueShow: number;
    WinProbability: number;
    ProjectedNetShow: number;
}

export interface ResponseTimeDataResponse extends SimpleResponse {
    rptResponseTime: RptResponseTime[];
    rptResponseTimeAll: RptResponseTimeAll[];
}

export interface ResponseTimeFilterResponse extends SimpleResponse {
    isTeamSection: boolean;
    isTeamdd: boolean;
    isTeamLabel: boolean;
    teamdd: TeamCodes[];
    teamTxt: string;
    isOfficeSection: boolean;
    isOfficedd: boolean;
    isOfficeLabel: boolean;
    officedd: OfficeCodes[];
    officeTxt: string;
}

export interface RptResponseTime {
    clpUserID: number;
    team: string;
    office: string;
    userLastFirst: string;
    responseTime: number;
    avgResponseSecs: number;
    avgResponseMinutes: number;
    contacts: number;
    inboundTexts: number;
}
export interface RptResponseTimeAll {
    users: number;
    responseTime: number;
    avgResponseSecs: number;
    avgResponseMinutes: number;
    contacts: number;
    inboundTexts: number;
}

export interface ReportFormData {
    officeCode: number;
    teamCode: number;
    clpUserId: number;
    strStart: string;
    strEnd: string;
}

export interface DuplicateLeads {
    leads: number;
    revenue: Date;
    probability: Date;
    leadStatusCode: string;
    sorder: string;
}

export interface DuplicateLeadsResponse {
    duplicateLeadsList: DuplicateLeads[];
}

export interface IHApptSetter {
    IHApptSetterId: number;
    isUsedInReport: boolean;
    fullName: string;
}

export interface NonApptSettersUsersResponse extends SimpleResponse {
    nonApptSettersUserList: IntDropDownItem[];
}

export interface NonAssignedUsersResponse extends SimpleResponse {
    nonAssignedUserList: IntDropDownItem[];
}

export interface SelectedUserSummaryData {
    value: string;
    text: string;
    isSelected: boolean;
}

export interface QuickBlastFormData {
    filter: number;
    subjectLine: string;
    emailTemplateId: number;
}

export interface TagModel {
    cLPCompanyID: number;
    ownerType: number;
    tag: string;
    tagID: number;
}

export interface TimePeriod {
    startDt: Date;
    endDt: Date;
    numberOfMonths: number;
}

export interface SendResultToNewObj {
    clpCompanyId: number;
    selectedCompanyId: number;
    companyType: eCompanyType;
    clpUserId: number;
    strUsers: string[];
    selectedTagIds: number[];
    tagSearchType: number;
    clickId: number;
    searchContactBy: SearchContactBy;
    ownerType: eNoteOwnerType;
    selectedDropdownId: number;
    isBulkActionSelIndexChanged: boolean;
    startDate: string;
    endDate: string;
    eDim1: string;
    dim1Value: string;
    eDim2: string;
    dim2Value: string;
    dateFilter: string;
    filterAttempt: string;
    filterAttemptOperator: string;
    cbIncludeNoCalls: boolean;
    searchQueryObj: SearchQueryResponse;
    searchTxt: string;
    selectedOption: string;
    blnIsMine: boolean;
}

export interface TxtMsgIBResponse extends SimpleResponse {
    txtMsgIBResponse: TxtMsgIB;
}

export interface LeadStatusListResponse extends SimpleResponse {
    leadStatusCodeList: LeadStatus[];
}

export enum eScoreType {
    Unknown = 0,
    Mailing_Open = 1,
    Email_Click = 2,
    Event_FT = 3,
    Event_Appt = 4,
    Event_Email = 5,
    Event_CT = 6,
    Event_Task = 7,
    Email_Open = 8,
    Text_Keyword = 9,
    Event_TxtMsg = 10,
    Event_VoiceDrop = 11,
    Event_VoiceCall = 12,
    Event_IBTxtMsg = 13,
    Event_IBVoiceCall = 14,
    Event_IBVoiceCallAnswered = 15
}


export interface CustomSearchResponse {
    customSearchID: number;
    clpCompanyID: number;
    clpUserID: number;
    objectType: number;
    displayName: string;
    displayClause: string;
    sqlClause: string;
    sqlClauseCount: string;
    whereClause: string;
    orderBy: string;
    isSavedSearch: boolean;
    dtCreated: string;
    havingScore: string;
}
